export function generateKey(prefix = 'prefix') {
    return `${prefix}_${Math.random().toString(36).substr(2, 9)}`;
}
//# sourceMappingURL=random.js.map